import React, { useEffect } from "react";
import { Badge, Box, Card, Container, Grid, Typography } from "@mui/material";
import {
  Mail as MailIcon,
  WorkspacePremium,
  Work,
  LinkedIn,
  Lock,
  LockOpen,
} from "@mui/icons-material";
import UserInfo from "./UserInfo";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getDeveloper,
  pending,
} from "../../features/Developers/developerSlice";

const Dashboard = () => {
  const { developer, developers } = useSelector((state) => state.developers);
  const { dev } = useSelector((state) => state.dev);
  // const { dev } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDeveloper(dev?.id));
  }, []);
  const { home, attributes, skills, projects, socials } = developer;
  return (
    <>
      <Container>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6} md={12}>
              <Box>
                <Card elevation={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                      height: "100px",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="h4">{projects?.length}</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography>projects</Typography>
                      <Work color="action" />
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={6} md={12}>
              <Box>
                <Card elevation={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                      height: "100px",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="h4">{skills?.length}</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography>Skills</Typography>
                      <WorkspacePremium color="action" />
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={6} md={12}>
              <Box>
                <Card elevation={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                      height: "100px",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="h4">{socials?.length}</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography>Socials</Typography>
                      <LinkedIn color="action" />
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={6} md={12}>
              <Box>
                <Card elevation={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                      height: "100px",
                      flexDirection: "column",
                    }}
                  >
                    {/* <Typography variant="h4">{attributes?.has2fa}</Typography> */}
                    {attributes?.has2fa ? (
                      <Typography variant="h5"> ENABLED </Typography>
                    ) : (
                      <Typography variant="h5"> DISABLED </Typography>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography>2FA</Typography>
                      {attributes?.has2fa ? <Lock /> : <LockOpen />}
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default Dashboard;
